import { LocalizePositionService, MapSettingsService } from '@addins/core/map';
import { ButtonsProviderService, CardsProviderService } from '@addins/core/singlecallcard';
import { DestinationType, StartItineraryService } from '@addins/external-itinerary';
import { Injectable } from '@angular/core';
import { Coordinate } from '@models/coordinate';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { AddinExecute, Execute } from '@techwan/ionic-core';
import { filter } from 'rxjs/operators';
import { DestinationSelectComponent } from '../../../components/destination-select/destination-select.component';
import { LocalizeDestinationTool } from '../../../schema/localize-destination-tool';
import { NavigateToDestinationTool } from '../../../schema/navigate-to-destination-tool';
import { DestinationProviderService } from '../../destination-provider/destination-provider.service';

@AddinExecute({
  name: 'Destination tools setup'
})
@Injectable()
export class DestinationToolsSetupService extends Execute {
  private navigateToDestinationTool: NavigateToDestinationTool;
  private localizeDestinationTool: LocalizeDestinationTool;

  constructor(
    private cardsProvider: CardsProviderService,
    private destinationsProvider: DestinationProviderService,
    private buttonsProvider: ButtonsProviderService,
    private localizePosition: LocalizePositionService,
    private startItineraryService: StartItineraryService,
    private mapSettingsService: MapSettingsService
  ) {
    super();
  }

  init() {
    super.init();
    this.navigateToDestinationTool = new NavigateToDestinationTool();
    this.localizeDestinationTool = new LocalizeDestinationTool();
    this.destinationsProvider.setup();
  }

  execute() {
    this.destinationsProvider.$ready.pipe(filter(ready => ready)).subscribe(() => this.onDestiationsReady());
  }

  private onDestiationsReady() {
    this.cardsProvider.add(DestinationSelectComponent);

    this.navigateToDestinationTool.onClick.subscribe(event => this.navigateToDestination());
    this.buttonsProvider.add(this.navigateToDestinationTool);

    this.localizeDestinationTool.onClick.subscribe(event => this.localizeDestination(event.target));
    this.buttonsProvider.add(this.localizeDestinationTool);

    this.destinationsProvider.$current.subscribe(() => this.onDestinationProviderChanged());
  }

  private onDestinationProviderChanged() {
    this.localizeDestinationTool.show = this.destinationsProvider.value !== null;
    this.navigateToDestinationTool.show = this.destinationsProvider.value !== null;
  }

  private navigateToDestination() {
    const coordinate: Coordinate = {
      x: this.destinationsProvider.value.CoordX,
      y: this.destinationsProvider.value.CoordY,
      epsg: this.mapSettingsService.getSystemProjection()
    };
    this.startItineraryService.navigateTo({
      location: coordinate,
      destinationType: DestinationType.Destination,
      destinationId: this.destinationsProvider.value.ResAddressUid
    });
  }

  private localizeDestination(callcard: CallCard) {
    this.localizePosition.localize({
      target: callcard,
      coordinates: [
        {
          x: this.destinationsProvider.value.CoordX,
          y: this.destinationsProvider.value.CoordY,
          epsg: this.mapSettingsService.getSystemProjection()
        }
      ]
    });
  }
}
